module.exports = __webpack_public_path__ + "static/media/pay_img.30497a5b.svg";